import request from '@/util/request'
//消息盒子
export function getSecondaryList(params) { // 二级获取报警消息
  params.lan = stage.languageId
  return request({
    url: `/message-s/message/msg-alert`,
    method: 'get',
    params
  })
}
export function getMsgCategory() { // 获取所有类型的消息
	let params={lan:stage.languageId}
  return request({
    url: `/message-s/message/msg-category`,
    method: 'get',
    params
  })
}
export function getUnreadedTotal() { // 获取未读总数
  return request({
    url: `/message-s/message/unreaded/total`,
    method: 'get',
  })
}
export function getAlertMsgChange(data){ // 获取消息状态变更
  return request({
    url: `/message-s/message/msg-change`,
    method: 'post',
    data
  })
}
export function getDefault () { // 默认规则列表
  return request({
    url: `/message-s/rule/default-rule`,
    method: 'get',
  })
}
export function updateDefault (data) { // 修改默认规则列表
  return request({
    url: `/message-s/rule/default-rule`,
    method: 'put',
    data
  })
}
export function getChannelConfig() { // 获取基础报警
  return request({
    url: `/message-s/rule/channel-config`,
    method: 'get'
  })
}
export function getSpecial (params) { // 特殊规则列表
	params.language = stage.languageId
  return request({
    url: `/message-s/rule/special-rules`,
    method: 'get',
    params
  })
}
export function getSpecialById (id) { // 获取特殊规则
	  let params = {
	  	language:stage.languageId
	  }
	  return request({
	    url: `/message-s/rule/special-rules/${id}`,
	    method: 'get',
	    params
	  })
}
export function del(id) { //删除特殊规则
  return request({
    url: `/message-s/rule/special-rules/${id}`,
    method: 'delete'
  })
}
export function getChannelMessage () { // 特殊规则列表
  return request({
    url: `/message-s/rule/channel-message-statistics`,
    method: 'get',
  })
}
export function getAlertBase(params) { // 获取基础报警
	params.language=stage.languageId
  return request({
    url: `/message-s/rule/alert-base-infos`,
    method: 'get',
    params
  })
}
export function insertSpecial(data){
	 return request({
    url: `/message-s/rule/special-rules`,
    method: 'post',
    data
  })
}
export function updataSpecial(data){
	 return request({
    url: `/message-s/rule/special-rules`,
    method: 'put',
    data
  })
}
export function messageAlertList(params,id){
	  params.language=stage.languageId
	 return request({
    url: `/message-s/message/search/${id}`,
    method: 'get',
    params
  })
}
export function judgeSpecialRules(id){
	 return request({
    url: `/message-s/rule/special-rules/exists/${id}`,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/manage/message.js